<template lang="pug">
span(:class="{ 'property-modified': isPropertyModified() }")
  span.capitalize {{ title }}
  span(v-if="!hideModified")  {{ propertyModified() }}
</template>

<script>
import mPropertyManage from '@/mixins/propertyManage'

export default {
  name: 'PropertyText',

  mixins: [mPropertyManage],

  props: {
    dataOriginal: Object,
    dataForm: Object,
    title: String,
    property: String,
    index: Number,
    caseSensitive: Boolean,
    hideModified: Boolean
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elements/Property.vue